import { useRef } from 'react'
import styles from './DavidPifView.module.css'
import { TheatricalReleaseResult } from '@/services/Theatrical/queries'
import { Faq } from '@/types/codegen-federation'
import { ClaimTicketSection } from './components/ClaimTicketSection'
import { DavidGoliathSection } from './components/DavidGoliathSection'
import { EndCtaSection } from './components/EndCtaSection'
import { FaqSection } from './components/FaqSection'
import { HelpLightSection } from './components/HelpLightSection'
import { Hero } from './components/Hero'
import { HowItWorksSection } from './components/HowItWorksSection'
import { ImgFullParallax } from './components/ImgFullParallax'
import { InspireGenSection } from './components/InspireGenSection'
import { NameInCreditsSection } from './components/NameInCreditsSection'
import { PifOverlay } from './components/PifOverlay'
import { SpecialMessageSection } from './components/SpecialMessageSection'
import { StoriesSongsSection } from './components/StoriesSongsSection'
import { SuperheroesSection } from './components/SuperheroesSection'
import { PifOverlayProvider } from './contexts/PifOverlayContext'

interface DavidPifViewProps {
  theatricalRelease: TheatricalReleaseResult
}

export function DavidPifView({ theatricalRelease }: DavidPifViewProps) {
  const heroRef = useRef<HTMLElement>(null)
  const releaseDate = theatricalRelease?.region?.releaseDate

  return (
    <PifOverlayProvider>
      <div className={`david-pif-view relative min-h-screen w-full overflow-x-hidden bg-[#141447] ${styles.container}`}>
        {/* <ShareDavidCta show={showCta} /> */}

        <main className="relative">
          <Hero ref={heroRef} />
          <HelpLightSection releaseDate={releaseDate} />
          <ClaimTicketSection />
          <InspireGenSection />
          <NameInCreditsSection />
          <SpecialMessageSection />
          <SuperheroesSection />
          <StoriesSongsSection />
          <DavidGoliathSection />
          <HowItWorksSection />
          <EndCtaSection />
          <ImgFullParallax />
          <FaqSection faqs={theatricalRelease?.region?.faqs as Faq[]} />
        </main>

        <PifOverlay releaseDate={releaseDate} projectSlug="david" />
      </div>
    </PifOverlayProvider>
  )
}
